
<div>
    <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                fab
                v-bind    = "attrs"
                v-on      = "on"
                :color    = "buttonColor"
                :disabled = "disabled"
                class     = "mb-3"
                @click    = "onClick"
                small
            >
                <v-icon :class = "iconColor">{{ icon }}</v-icon>
            </v-btn>
        </template>
        <span>{{ $t( label ) }}</span>
    </v-tooltip>
</div>
